var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B7AAF",
    d: "M45.7,-65.7C58,-63.2,65.8,-48.4,69.4,-33.7C73,-19,72.4,-4.3,68.6,8.6C64.8,21.6,58,32.9,48.4,39.3C38.8,45.7,26.5,47.2,16.2,46C5.9,44.8,-2.5,40.9,-16.8,43.2C-31.1,45.4,-51.4,53.8,-59,48.9C-66.6,44.1,-61.5,26.1,-64.5,9C-67.5,-8.2,-78.4,-24.5,-70.3,-27.9C-62.1,-31.2,-34.9,-21.6,-20,-22.8C-5.1,-24.1,-2.6,-36.2,7.1,-47.2C16.7,-58.3,33.4,-68.2,45.7,-65.7Z",
    transform: "translate(100 100)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.3260cb7799fd8756d9ee08c043c56f88.svg";
export { ForwardRef as ReactComponent };